import { render, staticRenderFns } from "./AdminInitial.vue?vue&type=template&id=32975b2e"
import script from "./AdminInitial.vue?vue&type=script&lang=js"
export * from "./AdminInitial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports